import { Link } from 'react-router-dom';

import type { LandingCopy } from './copy';
import { WhatsAppButton } from './WhatsAppButton';

/** The last thing before the footer: start the pilot, or ask us on WhatsApp first. */
export const ClosingCta = ({
  copy,
  signup,
  linkProps,
}: {
  copy: LandingCopy['closing'];
  signup: string;
  linkProps: Record<string, () => void>;
}) => (
  <section id="start" className="lp-closing" aria-labelledby="lp-closing-title">
    <div className="lp-container">
      <h2 id="lp-closing-title">{copy.title}</h2>
      <p>{copy.body}</p>
      <div className="lp-actions">
        <Link to="/signup" className="lp-btn lp-btn--primary" {...linkProps}>
          {signup}
        </Link>
        <WhatsAppButton label={copy.whatsapp} text={copy.whatsappText} />
      </div>
    </div>
  </section>
);
